// MultiStepForm.js
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Container,
  Form,
  Button,
  ProgressBar,
  Nav,
  Alert,
} from "react-bootstrap";
import SignaturePad from "react-signature-canvas"; // Import the SignaturePad component
import "./Signature.css";
import { connect } from "react-redux";
import { put } from "../../api";
import { dataURLtoBlob } from "../../utils/dataURLtoBlob";
import { toast } from "react-toastify";
import { triggerButtonClick } from "../../utils/triggerLibraryButton";
import { uploadDocumentAndGetUrl } from "../../utils/uploadDocument";
import { getSasToken } from "../../store/thunk/user";
import LiteracyNumeracyDownload from "./Download/LiteracyNumeracyDownload";
import { updateForm } from "../../utils/updateForm";
import { Tabs, Tab, Box } from "@mui/material";

const LiteracyNumeracy = ({
  currentDocument,
  documentList,
  user,
  sasToken,
  ipAddress,
  getSasToken,
}) => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(0); // Progress percentage for each step
  const [value, setValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [formData, setFormData] = useState({
    firstName: "",
    surName: "",
    homeAddress: "",
    postCode: "",
    mobile: "",
    landlineNumber: "",
    email: "",
    phone: "",
    simon: "",
    jennifer: "",
    september: "",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
    answer5: "",
    answer6: "",
    answer7: "",
    answer8: "",
    answer9: "",
    answer10: "",
    consent: false,
    signature: "", // Store the signature data as a string
  });
  const [errors, setErrors] = useState({});
  const sigPadRef = useRef(null); // Reference to the SignaturePad component
  useEffect(() => {
    setFormData(currentDocument);
    if (currentDocument?.step) {
      setStep(currentDocument?.step);
    }
    if (currentDocument?.progress) {
      setProgress(currentDocument?.progress);
    }
    if (currentDocument?.progress === 100) {
      getSasToken();
    }
  }, []);
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  // Function to validate each step
  const validateStep = () => {
    let formErrors = {};
    if (step === 1) {
      if (!formData.firstName) formErrors.firstName = "First Name is required";
      if (!formData.surName) formErrors.surName = "Surname is required";
      if (!formData.homeAddress)
        formErrors.homeAddress = "Home address is required";
      if (!formData.postCode) formErrors.postCode = "Post code is required";
      if (!formData.mobile) formErrors.mobile = "Mobile number is required";
      if (!/^\d{11}$/.test(formData.mobile)) {
        formErrors.mobile =
          "Mobile number must be exactly 11 digits and contain only numbers";
      }
      if (!formData.email) {
        formErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        formErrors.email = "Email is invalid";
      }
    } else if (step === 2) {
      if (!formData.simon) {
        formErrors.simon = "Simon is required";
      }
      if (!formData.september) {
        formErrors.september = "September is required";
      }
    } else if (step === 3) {
      if (!formData.consent) formErrors.consent = "You must agree to the terms";
      if (sigPadRef.current.isEmpty())
        formErrors.signature = "Signature is required"; // Check if the signature pad is empty
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Function to go to the next step
  const nextStep = () => {
    if (validateStep()) {
      const payload = {
        [currentDocument["key"]]: {
          name: currentDocument?.name,
          ...formData,
          progress: progress + 33,
          step: step + 1,
        },
      };
      updateForm(payload, documentList, user);
      setStep(step + 1);
      setProgress(progress + 33);
    }
  };

  // Function to go to the previous step
  const prevStep = () => {
    setStep(step - 1);
    if (progress === 0) {
    } else {
      setProgress(progress - 33);
    }
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep()) {
      // Get the signature data as a base64 image
      const signatureImage = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");

      const signatureBlob = dataURLtoBlob(signatureImage);
      setFormData({ ...formData, signature: signatureImage });
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append("file", signatureBlob, "signature.png");
      // Send the FormData using postMultiPartFormData
      const documentUrl = await uploadDocumentAndGetUrl(
        formDataSign,
        user?.token
      );
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            progress: 100,
            step: step,
            ipAddress: ipAddress,
            signature: documentUrl,
            signDate: new Date(),
          },
        };
        updateForm(payload, documentList, user);
        toast.success("Successfully filled the form.");
        triggerButtonClick();
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
      // Additional submit logic here, such as sending formData to the server
    }
  };
  // Clear the signature pad
  const clearSignature = () => {
    sigPadRef.current.clear();
    setFormData({ ...formData, signature: "" });
  };

  return (
    <Container className="mt-5">
      {currentDocument?.progress === 100 ? (
        <>
          <LiteracyNumeracyDownload
            data={currentDocument}
            sasToken={sasToken}
            user={documentList?.userDetail}
          />
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="basic tabs example"
              className="tab mt-2"
            >
              <Tab label="Personal Information" />
              <Tab label="Assessment" />
            </Tabs>
            {value === 0 && (
              <div className="container">
                <div className="row">
                  <h2>Personal Information</h2>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between"><strong>First Name</strong> <span>{currentDocument?.firstName || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Surname</strong> <span>{currentDocument?.surName || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Home Address</strong> <span>{currentDocument?.homeAddress || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Postcode</strong> <span>{currentDocument?.postCode || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Mobile Number</strong> <span>{currentDocument?.mobile || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Landline Number</strong> <span>{currentDocument?.landlineNumber || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Email Address</strong> <span>{currentDocument?.email || '--'}</span></li>
                  </ul>
                </div>
              </div>
            )}
            {value === 1 && (
              <Box sx={{ p: 3 }}>
                <div className="container">
                <div className="row">
                  <h2>Assessment</h2>
                  <p>
                  A = Alpha
                  <br />
                  B = Bravo
                  <br />
                  C = Charlie
                  <br />
                  D = Delta
                  <br />
                  E = Echo
                  <br />
                  F = Foxtrot
                  <br />
                  G = Golf
                  <br />
                  H = Hotel
                  <br />
                  I = India
                  <br />
                  J = Juliet
                  <br />
                  K = Kilo
                  <br />
                  L = Lima
                  <br />
                  M = Mike
                  <br />
                  N = November
                  <br />
                  O = Oscar
                  <br />
                  P = Papa
                  <br />
                  Q = Quebec
                  <br />
                  R = Romeo
                  <br />
                  S = Sierra
                  <br />
                  T = Tango
                  <br />
                  U = Uniform
                  <br />
                  V = Victor
                  <br />
                  W = Whiskey
                  <br />
                  X = X-ray
                  <br />
                  Y = Yankee
                  <br />Z = Zulu
                </p>
                <p>
                  <strong>
                    Using the phonetic alphabet above provided, please complete
                    the questions below.
                  </strong>
                </p>
                <p>Example : Kevin = Kilo, Echo, Victor, India, November</p>
                  <ul class="list-group ,t-2">
                    <li class="list-group-item d-flex justify-content-between"><strong>Simon:</strong> <span>{currentDocument?.firstName || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Jennifer:</strong> <span>{currentDocument?.surName || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>September:</strong> <span>{currentDocument?.homeAddress || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between">Please complete the following numeric questions</li>
                    <li class="list-group-item d-flex justify-content-between"><strong>5 x 8 =</strong> <span>{currentDocument?.answer1 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>6 x 9 =</strong> <span>{currentDocument?.answer2 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>7 x 4 =</strong> <span>{currentDocument?.answer3 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>8 x 6 =</strong> <span>{currentDocument?.answer4 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>3 x 12 =</strong> <span>{currentDocument?.answer5 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>14 + 3+ 9 – 2 =</strong> <span>{currentDocument?.answer6 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>½ + ¼ =</strong> <span>{currentDocument?.answer7 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>1.5 x 4 =</strong> <span>{currentDocument?.answer8 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>15 x 100 =</strong> <span>{currentDocument?.answer9 || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>1000 / 4 =</strong> <span>{currentDocument?.answer10 || '--'}</span></li>
                  </ul>
                </div>
              </div>
              </Box>
            )}
          </Box>
        </>
      ) : (
        <>
          <Nav variant="pills" className="justify-content-center mb-3">
            <Nav.Item>
              <Nav.Link
                className={step === 1 ? "text-light" : ""}
                active={step === 1}
              >
                Step 1
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={step === 2 ? "text-light" : ""}
                active={step === 2}
              >
                Step 2
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={step === 3 ? "text-light" : ""}
                active={step === 3}
              >
                Step 3
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <ProgressBar now={progress} className="mb-4" />

          <Form onSubmit={handleSubmit}>
            {step === 1 && (
              <div>
                <h3>Section 1: Personal Information</h3>
                <Form.Group className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    isInvalid={!!errors.firstName}
                    required
                  />
                  {errors.firstName && (
                    <Alert variant="danger">{errors.firstName}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Surname</Form.Label>
                  <Form.Control
                    type="text"
                    name="surName"
                    value={formData.surName}
                    onChange={handleChange}
                    isInvalid={!!errors.surName}
                    required
                  />
                  {errors.surName && (
                    <Alert variant="danger">{errors.surName}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Home Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="homeAddress"
                    value={formData.homeAddress}
                    onChange={handleChange}
                    isInvalid={!!errors.homeAddress}
                    required
                  />
                  {errors.homeAddress && (
                    <Alert variant="danger">{errors.homeAddress}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Postcode</Form.Label>
                  <Form.Control
                    type="text"
                    name="postCode"
                    value={formData.postCode}
                    onChange={handleChange}
                    isInvalid={!!errors.postCode}
                    required
                  />
                  {errors.postCode && (
                    <Alert variant="danger">{errors.postCode}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    isInvalid={!!errors.mobile}
                    required
                  />
                  {errors.mobile && (
                    <Alert variant="danger">{errors.mobile}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Landline Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="landlineNumber"
                    value={formData.landlineNumber}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                    required
                  />
                  {errors.email && (
                    <Alert variant="danger">{errors.email}</Alert>
                  )}
                </Form.Group>
                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              </div>
            )}

            {step === 2 && (
              <div>
                <h3>Step 2: Assessment</h3>
                <p>
                  A = Alpha
                  <br />
                  B = Bravo
                  <br />
                  C = Charlie
                  <br />
                  D = Delta
                  <br />
                  E = Echo
                  <br />
                  F = Foxtrot
                  <br />
                  G = Golf
                  <br />
                  H = Hotel
                  <br />
                  I = India
                  <br />
                  J = Juliet
                  <br />
                  K = Kilo
                  <br />
                  L = Lima
                  <br />
                  M = Mike
                  <br />
                  N = November
                  <br />
                  O = Oscar
                  <br />
                  P = Papa
                  <br />
                  Q = Quebec
                  <br />
                  R = Romeo
                  <br />
                  S = Sierra
                  <br />
                  T = Tango
                  <br />
                  U = Uniform
                  <br />
                  V = Victor
                  <br />
                  W = Whiskey
                  <br />
                  X = X-ray
                  <br />
                  Y = Yankee
                  <br />Z = Zulu
                </p>
                <p>
                  <strong>
                    Using the phonetic alphabet above provided, please complete
                    the questions below.
                  </strong>
                </p>
                <p>Example : Kevin = Kilo, Echo, Victor, India, November</p>
                <Form.Group className="mb-3">
                  <Form.Label>Simon</Form.Label>
                  <Form.Control
                    type="text"
                    name="simon"
                    value={formData.simon}
                    onChange={handleChange}
                    isInvalid={!!errors.simon}
                    required
                  />
                  {errors.simon && (
                    <Alert variant="danger">{errors.simon}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Jennifer</Form.Label>
                  <Form.Control
                    type="text"
                    name="jennifer"
                    value={formData.jennifer}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>September</Form.Label>
                  <Form.Control
                    type="text"
                    name="september"
                    value={formData.september}
                    onChange={handleChange}
                    isInvalid={!!errors.september}
                    required
                  />
                  {errors.september && (
                    <Alert variant="danger">{errors.september}</Alert>
                  )}
                </Form.Group>
                <p>
                  <strong>
                    Please complete the following numeric questions
                  </strong>
                </p>
                <Form.Group className="mb-3">
                  <Form.Label>5 x 8 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer1"
                    value={formData.answer1}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>6 x 9 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer2"
                    value={formData.answer2}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>7 x 4 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer3"
                    value={formData.answer3}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>8 x 6 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer4"
                    value={formData.answer4}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>3 x 12 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer5"
                    value={formData.answer5}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>14 + 3+ 9 – 2=</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer6"
                    value={formData.answer6}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>½ + ¼ =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer7"
                    value={formData.answer7}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>1.5 x 4 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer8"
                    value={formData.answer8}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>15 x 100=</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer9"
                    value={formData.answer9}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>1000 / 4 =</Form.Label>
                  <Form.Control
                    type="text"
                    name="answer10"
                    value={formData.answer10}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Button variant="secondary" onClick={prevStep} className="me-2">
                  Previous
                </Button>
                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              </div>
            )}

            {step === 3 && (
              <div>
                <h3>Step 3: Sign and Submit</h3>
                <p>
                  By signing this page, I confirm that I fully understand the
                  content and agree to adhere to it at all times. I also agree
                  that all the details provided in this document are accurate
                  and complete to the best of my knowledge.
                </p>
                <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={sigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.signature && (
                    <Alert variant="danger">{errors.signature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="consent"
                    label="Clear By ticking this box I consent to the company processing my
                data and the evidence of this document being stored within their
                system for the purpose of work finding services."
                    checked={formData.consent} // Use checked for checkboxes
                    onChange={handleChange}
                    isInvalid={!!errors.consent}
                  />
                  {errors.consent && (
                    <Alert variant="danger">{errors.consent}</Alert>
                  )}
                </Form.Group>
                <Button variant="secondary" onClick={prevStep} className="me-2">
                  Previous
                </Button>
                <Button variant="success" type="submit">
                  Submit
                </Button>
              </div>
            )}
          </Form>
        </>
      )}
      {/* Stepper Navigation */}
    </Container>
  );
};
const mapStateToProps = (state) => ({
  currentDocument: state.user.currentDocument,
  documentList: state.user.documentList,
  user: state.user.loggedInUserData,
  sasToken: state.user.sasToken,
  ipAddress: state.user.ipAddress,
});

export default connect(mapStateToProps, { getSasToken })(LiteracyNumeracy);
